// Import all of Bootstrap’s JS
import * as bootstrap from 'bootstrap'